import styled from "styled-components";

let titleBarHeight = 60;

export const ElectricWheelConciseOverviewWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    color: #FFFFFF;
    letter-spacing: 2px;
    color: #EFEFEF;
    background-color: rgb(5, 12, 38);
`;

export const ElectricWheelConciseInnerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 850px;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-image: url("/static/images/big-screen/electric-wheel-concise/overview-background.png");
    background-size: 100% 100%;
`;

export const ScreenTitleBar = styled.div`
    position: absolute;
    z-index: 100;
    left: 0%;
    top: 0%;
    width: 100%;
    height: ${titleBarHeight}px;
    padding: 0px 10px 0px 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
`;

export const OverviewBigScreenContent = styled.div`
    display: grid;
    position: absolute;
    top: calc(${titleBarHeight}px);
    width: 100%;
    height: calc(100% - ${titleBarHeight}px);
    padding: 10px 30px 32px 30px;
    overflow-x: hidden;
    overflow-y: hidden;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-auto-rows: 270px;
    grid-gap: 40px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
    z-index: 100;
`;

export const DeviceWrapper = styled.div`
    background-color: rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    box-sizing: border-box;
`;

export const DeviceHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const DeviceIcon = styled.img`
    width: 60px;
`;

export const DeviceName = styled.div`
    font-size: 18px;
`;

export const DeviceStatus = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 24px;
    padding: 0px 12px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.1);
`;

export const DeviceMetricsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
`;

export const DeviceMetricWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 50%;
    gap: 10px;
`;

export const DeviceMetricStatusWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
`;

export const DeviceMetricStatus = styled.div`
    display: flex;
    align-items: center;
    font-size: 16px;
    height: 24px;
    padding: 4px 12px 2px 12px;
    border-radius: 15px;
    background-color: rgba(255, 255, 255, 0.1);
`;

export const DeviceMetricValueWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 55px;
    padding: 20px;
    gap: 10px;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.5);
`;

export const DeviceMetricValue = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 10px;
    font-size: 24px;
    font-weight: 600;
`;

export const DeviceMetricUnit = styled.div`
    font-size: 16px;
    font-weight: 100;
`;

export const DeviceMetricName = styled.div`
    font-size: 14px;
`;

export const DeviceFooter = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
`;

export const LastUpdatedTime = styled.div`

`;

export const ViewDeviceDetails = styled.div`
    cursor: pointer;
`;




